import './photo.scss';

export default () => {
	$( window ).scroll( function ( ) {
		$( '.js-parallax-slide' ).each( function ( i, el ) {
			let img = $( el ).find( 'img' );

			img.css( {
				scale: 1.3,
			} );
			let off = $( window ).height();
			let fromBottom = ( $( el ).offset().top - off ).toFixed();
			let percent = ( window.scrollY - fromBottom ) / off;
			let imgH = img.height() * .3;
			let scrollYimg = ( ( imgH / 2 ) - imgH ) * ( .5 - percent );

			img.css( {
				transform: `translateY(${scrollYimg}px)`,
			} );
		} );
	} );
};
